import { Badge } from 'antd'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Routing, { SideMenu } from '../../components/reusable/routing'

import { useReports, useLatestPathname } from '../../modules.js'

import ConsultationQueue from '../../components/pages/Consultation.js'

import Forwards from './Forwards.js'
import Referrals from './Attached.js'
import Appointments from './Appointments.js'

let menu = [
    {
        path: 'queue',
        title: 'Queue',
        component: () => <ConsultationQueue path="/app/consultation/queue" />
    },
    {
        path: 'appointments',
        title: 'Appointments',
        component: Appointments
    },
    {
        path: 'attached-documents',
        title: 'Attached Documents',
        component: () => <Referrals destination="Doctor" path="/app/consultation/attached-documents" />
    },
    {
        path: 'forwards',
        title: 'Forwards',
        component: () => <Forwards destination="Doctor" path="/app/consultation/forwards" />
    }
]

const Consultation = () => {
    const history = useHistory()
    const { user } = useSelector(state => state.application)
    const pathname = useLatestPathname()

    const [Reports, reports] = useReports("consultation")

    // const [Inventory, store, requests] = useInventory(storeName)

    useEffect(() => {
        menu[4] = {
            path: 'reports',
            title: 'Reports',
            component: () => <Reports reports={ reports } department="consultation" />
        }

        const target = `/app/consultation/${menu[0].path}`
        if (!pathname.current.startsWith(target)) history.push(target)
    }, [user, reports])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Consultation</p>
                <SideMenu namespace="consultation" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="consultation" menu={ menu } />
            </div>
        </div>
    )
}

export default Consultation